import { oauthProviderClient } from "@better-auth/oauth-provider/client"
import { emailOTPClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"

import { getBearer, isDesktop, setBearer } from "./desktop-token"

export const authClient = createAuthClient({
    /** The base URL of the server (optional if you're using the same domain) */
    baseURL: import.meta.env.VITE_API_URL,
    // Mirrors the server emailOTP plugin so authClient.emailOtp.* (send /
    // verify / reset-password) is available client-side.
    plugins: [
        emailOTPClient(),
        // MCP / OAuth provider pages (/oauth-sign-in, /oauth-consent). On those
        // pages the URL carries the provider's signed authorization query; this
        // plugin replays it as `oauth_query` on every non-GET auth call
        // (sign-in, OTP verify, consent), which is how the server resumes the
        // authorization flow after sign-in. Elsewhere the URL has no `sig`
        // param and the plugin does nothing.
        oauthProviderClient(),
    ],
    fetchOptions: {
        // Desktop has no session cookie — authenticate with the stored bearer
        // token. The function form is evaluated per-request (the token arrives
        // after sign-in). In a browser this returns undefined → no header →
        // cookie session.
        auth: {
            type: "Bearer",
            token: () => (isDesktop() ? getBearer() : undefined),
        },
        // …and the WRITE half. The server's bearer plugin returns a fresh token
        // in `set-auth-token` on every response that would have set a session
        // cookie (sign-in, sign-up, OTP verify, password reset). The desktop
        // renderer is served from an insecure cross-site http://localhost
        // origin, so the cookie is neither stored nor sent — without capturing
        // this header, those flows authenticate server-side and the credential
        // is dropped, leaving the app stuck on the sign-in screen. Google is
        // unaffected because its token arrives over IPC from the main process.
        onSuccess: (ctx) => {
            if (!isDesktop()) return
            const token = ctx.response.headers.get("set-auth-token")
            if (token) setBearer(token)
        },
    },
})
